
// function trackAppH5VisView () {
//   //Android:
// }
function setSpecialVersion () {
  console.log('setSpecialVersion 防止app内频繁的捕获方法未定义error');
}

function AHbrowserHide () {
  //Android: 关闭新开的页面之后执行 1；
  console.log('AHbrowserHide 防止app内频繁的捕获方法未定义error');
}
function AHbrowserDisplay () {
  //Android: 关闭新开的页面之后执行 2；
  console.log('AHbrowserDisplay 防止app内频繁的捕获方法未定义error');
}
function pauseAudiosVideos (/** 暂停音频、视频；IOS支持*/) {
  //在app进入后台时，会调用暂停这个方法，到前台时会调用恢复这个方法
  console.log('pauseAudiosVideos 防止app内频繁的捕获方法未定义error');
}
function resumeAudiosVideos (/** 恢复音频、视频；IOS支持*/) {
  //在app进入后台时，会调用暂停这个方法，到前台时会调用恢复这个方法
  console.log('resumeAudiosVideos 防止app内频繁的捕获方法未定义error');
}
//window.trackAppH5VisView = trackAppH5VisView;
window.setSpecialVersion = setSpecialVersion;
window.AHbrowserHide = AHbrowserHide;
window.AHbrowserDisplay = AHbrowserDisplay;
window.pauseAudiosVideos = pauseAudiosVideos;
window.resumeAudiosVideos = resumeAudiosVideos;
window.pageinfo = {};

const v = process.env.NODE_ENV !== 'production' ? new Date().getTime() : SCRIPT_VER;

const appendChildFactory = function (appendChild) {
  return function (node) {
    const tagName = node.tagName;
    if (tagName === 'LINK') {
      let href = node.href;
      if (href.indexOf('?') > -1) {
        href = href + '&';
      } else {
        href = href + '?';
      }
      href += 't=' + v;
      node.href = href;
    }
    else if (tagName === 'SCRIPT') {
      let src = node.src;
      if (src) {

        if (src.indexOf('?') > -1) {
          src = src + '&';
        } else {
          src = src + '?';
        }
        src += 't=' + v;
        if (src.indexOf(PUBLIC_PATH) > -1) {
          node.setAttribute('crossorigin', 'anonymous');
        }
      }
      node.src = src;
    }
    appendChild.bind(this)(node);
  };
};
const appendChild = HTMLHeadElement.prototype.appendChild;
HTMLHeadElement.prototype.appendChild = appendChildFactory(appendChild);

